import axios from "axios"
import { BaseUrl, JsonConfig } from "./BaseRepository"
import { ErrorMessage } from "../Utils/Utils";


//Fetching Credentials for a specific single client
export const GetSingleClientCreds = async ({ vms, client }) => {
    try {
        const Url = BaseUrl + "Client/ClientCredential/" + "?vms=" + vms + "&client=" + client;
        const Response = await axios.get(Url, JsonConfig);

        const JsonResponse = Response !== null ? Response.data : null;
        if (JsonResponse != null) {
            if (JsonResponse.statusCode === 200) {
                return JsonResponse.payload;
            }
            else {

                ErrorMessage(JsonResponse.message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}
//Fetching Credentials for All clients
export const GetAllClientCreds = async () => {
    try {
        const Url = BaseUrl +"Client/GetAllClientsCreds";
        const Response = await axios.get(Url, JsonConfig);

        const JsonResponse = Response !== null ? Response.data : null;
        if (JsonResponse != null) {
            if (JsonResponse.statusCode === 200) {
                return JSON.parse(JsonResponse.payload);
            }
            else {

                ErrorMessage(JsonResponse.message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}
//Updating credentials for clients
export const UpdateClientCredential = async (UpdatedData) => {
    try {
        const Url = BaseUrl + "Client/UpdateClientCredential";
        const Response = await axios.put(Url, UpdatedData, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        if (JsonResponse != null) {
            if (JsonResponse.statusCode === 200) {
                return JsonResponse;
            }
            else {

                ErrorMessage(JsonResponse.message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}

//Fetching Portal URL for All clients
export const GetClientLoginUrl= async (record) => {
    try {
        const username = encodeURIComponent(record.Client_Name)
        const Url = BaseUrl +`Client/getclientloginurl?vms=${record.VMS}&client=${username}`;
        const Response = await axios.get(Url, JsonConfig);

        const JsonResponse = Response !== null ? Response.data : null;
        if (JsonResponse != null) {
            if (JsonResponse.statusCode === 200) {
                return JSON.parse(JsonResponse.payload);
            }
            else {

                ErrorMessage(JsonResponse.message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}